"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
 var extendStatics = Object.setPrototypeOf ||
 ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
 function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
 return function (d, b) {
 extendStatics(d, b);
 function __() { this.constructor = d; }
 d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
 };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = require("./EventEmitter");
var util_1 = require("@firebase/util");
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
 __extends(VisibilityMonitor, _super);
 function VisibilityMonitor() {
 var _this = _super.call(this, ['visible']) || this;
 var hidden;
 var visibilityChange;
 if (typeof document !== 'undefined' &&
 typeof document.addEventListener !== 'undefined') {
 if (typeof document['hidden'] !== 'undefined') {
 // Opera 12.10 and Firefox 18 and later support
 visibilityChange = 'visibilitychange';
 hidden = 'hidden';
 }
 else if (typeof document['mozHidden'] !== 'undefined') {
 visibilityChange = 'mozvisibilitychange';
 hidden = 'mozHidden';
 }
 else if (typeof document['msHidden'] !== 'undefined') {
 visibilityChange = 'msvisibilitychange';
 hidden = 'msHidden';
 }
 else if (typeof document['webkitHidden'] !== 'undefined') {
 visibilityChange = 'webkitvisibilitychange';
 hidden = 'webkitHidden';
 }
 }
 // Initially, we always assume we are visible. This ensures that in browsers
 // without page visibility support or in cases where we are never visible
 // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
 // reconnects
 _this.visible_ = true;
 if (visibilityChange) {
 document.addEventListener(visibilityChange, function () {
 var visible = !document[hidden];
 if (visible !== _this.visible_) {
 _this.visible_ = visible;
 _this.trigger('visible', visible);
 }
 }, false);
 }
 return _this;
 }
 VisibilityMonitor.getInstance = function () {
 return new VisibilityMonitor();
 };
 /**
 * @param {!string} eventType
 * @return {Array.}
 */
 VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
 util_1.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
 return [this.visible_];
 };
 return VisibilityMonitor;
}(EventEmitter_1.EventEmitter));
exports.VisibilityMonitor = VisibilityMonitor;

//# sourceMappingURL=VisibilityMonitor.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/util/VisibilityMonitor.js
// module id = 102
// module chunks = 0